<div class="body">
  <div class="container mt-4">
    <div class="title-box">
      <h3>Modificar <span class="txtbienvenida-2">lugar de atención</span></h3>
    </div>
    <div class="container mt-4">
      <form [formGroup]="lugaresAtencionForm" (ngSubmit)="modificarLugar()">
        <div class="row myForm">
          <div class="col-sm-12 col-md-6 col-lg-6 col-xs-12">
            <div class="mb-3 required form-label">
              <label for="idDepartamento" class="form-label">Departamento de Atención</label>
              <select #dept id="dept" class="form-control selectpicker" formControlName="idDepartamento"
                title="Seleccione..." required>
                @for (dp of departamentos; track dp) {
                  <option [value]="dp.idDepartamento">
                    {{ dp.nombreDepartamento | uppercase }}
                  </option>
                }
              </select>
              <div class="invalid-feedback">Campo obligatorio</div>
            </div>
          </div>
          <div class="col-sm-12 col-lg-6 col-md-6 col-xs-12 mt-2 p-2">
            <div class="form-check form-switch d-inline-flex align-items-center gap-2">
              <input type="checkbox" class="form-check-input" formControlName="aplicaTodasCiudades"
                id="customSwitch1" checked (change)="validarCiudades($event)" />
                <label class="form-check-label" for="customSwitch1">Aplica para todas las ciudades</label>
              </div>
            </div>
          </div>
          <div class="row myForm">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xs-6">
              <div class="mb-3 required form-label">
                <label for="estado" class="form-label">Estado</label>
                <select formControlName="estado" class="form-control" title="Seleccione..." required>
                  <option value="HABILITADO">HABILITADO</option>
                  <option value="DESHABILITADO">DESHABILITADO</option>
                </select>
                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xs-6"
              [hidden]="lugaresAtencionForm.get('aplicaTodasCiudades').value !== false">
              <div class="mb-3 required form-label">
                <label for="ciudades" class="form-label">Ciudad de Atención</label>
                @if (departamentoCliente) {
                  <select #ciud id="ciud" data-size="6" data-live-search="true" formControlName="ciudades"
                    class="form-control selectpicker" multiple title="Seleccione...">
                    @for (cd of ciudades; track cd) {
                      <option [value]="cd.idCiudad">
                        {{ cd.nombreCiudad | uppercase }}
                      </option>
                    }
                  </select>
                }
                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
          </div>
          <div class="row justify-content-md-center g-3 mt-2">
            <div class="col-12 col-md-2 container-btn">
              <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;"
                [disabled]="!lugaresAtencionForm?.valid">
                Modificar
              </button>
            </div>
            <div class="col-12 col-md-2 container-btn">
              <button type="button" class="btn btn-primary hvr-shrink" style="width: 180px;"
                [routerLink]="['/intermediario/administracion/ubicaciones']">
                Volver
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="footer-body"></div>
    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
  </div>
